import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { cerrarEjercicio } from "../js/actions/index";
import "./ejercicio.scss";

const mapStateToProps = state => {
	return { ejercicio: state.ejercicio };
};
function mapDispatchToProps(dispatch) {
	return {
		cerrar: () => dispatch(cerrarEjercicio())
	};
}
const ConnectedEjercicio = ({ejercicio,cerrar}) => (
	<div id="popupEjercicio" className={ejercicio.visible?"show":"hide"} onClick={() => {cerrar();}}>
		<div className="ventana">
			<header>
				{ejercicio.titulo}
			</header>
			<div className="texto">
				{ejercicio.texto}
			</div>
			<footer id="pieEjercicio">Pulse para ocultar</footer>
		</div>
	</div>
);
ConnectedEjercicio.propTypes = {
	ejercicio:PropTypes.object,
	cerrar:PropTypes.func,
};

export default connect(mapStateToProps,mapDispatchToProps)(ConnectedEjercicio);